import { useEffect } from 'react'

const MarketingSourceCapture = () => {
  const search = typeof window !== 'undefined' ? window.location.search : ''
  useEffect(() => {
    const sourceCode = new URLSearchParams(search).get('source')?.trim()
    void fetch('/api/v1/user/marketing-source/capture', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(sourceCode ? { source_code: sourceCode } : {}),
    })
  }, [search])
  return null
}

export default MarketingSourceCapture
